module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('ol', {
    staticClass: "panes"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.currentTab === 0),
      expression: "resume.currentTab === 0"
    }],
    class: {
      acitve: _vm.resume.currentTab === 0
    }
  }, [_c('ProfileEditor'), _vm._v(" "), _c('ButtonGroup', {
    attrs: {
      "buttonType": _vm.porfileButton
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.currentTab === 1),
      expression: "resume.currentTab ===1"
    }],
    class: {
      acitve: _vm.resume.currentTab === 1
    }
  }, [_c('WorkHistoryEditor'), _vm._v(" "), _c('ButtonGroup', {
    attrs: {
      "buttonType": _vm.workHistoryButton
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.currentTab === 2),
      expression: "resume.currentTab === 2"
    }],
    class: {
      acitve: _vm.resume.currentTab === 2
    }
  }, [_c('ProjectEditor'), _vm._v(" "), _c('ButtonGroup', {
    attrs: {
      "buttonType": _vm.projectsButton
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.currentTab === 3),
      expression: "resume.currentTab ===3"
    }],
    class: {
      acitve: _vm.resume.currentTab === 3
    }
  }, [_c('SchoolEditor'), _vm._v(" "), _c('ButtonGroup', {
    attrs: {
      "buttonType": _vm.schoolButton
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.currentTab === 4),
      expression: "resume.currentTab ===4"
    }],
    class: {
      acitve: _vm.resume.currentTab === 4
    }
  }, [_c('ContactEditor'), _vm._v(" "), _c('ButtonGroup', {
    attrs: {
      "buttonType": _vm.contactButton
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaef9084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/Editor.vue
// module id = 204
// module chunks = 1